// extracted by mini-css-extract-plugin
export default {"form":"Account_form__f5eEk","input":"Account_input__+Cym8","notDetect":"Account_notDetect__+3Zi2"};